import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CosmicBackground } from './ui/CosmicBackground';
export function Hero() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen flex items-center justify-center pt-24 pb-16 overflow-hidden" data-id="element-44">
      <CosmicBackground data-id="element-45" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-46">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-col items-center" data-id="element-47">
          <motion.div variants={itemVariants} className="mb-6" data-id="element-48">
            <span className="inline-block font-body font-medium text-[12px] md:text-[14px] tracking-[3px] uppercase text-hubble-accent" data-id="element-49">
              BUILT, GOVERNED, AND SCALED ON HUBBLE
            </span>
          </motion.div>

          <motion.h1 variants={itemVariants} className="font-heading text-5xl md:text-[60px] lg:text-[72px] font-normal text-hubble-text leading-tight tracking-[-1px] mb-6 max-w-4xl" data-id="element-50">
            The platform for healthcare AI agents.
          </motion.h1>

          <motion.p variants={itemVariants} className="font-body text-[16px] md:text-[18px] text-hubble-body max-w-2xl mb-10 leading-[1.6]" data-id="element-51">
            One integration gives your agents context, governance, and quality,
            built for HIPAA from day one.
          </motion.p>

          <motion.div variants={itemVariants} className="flex items-center gap-4 mb-16" data-id="element-52">
            <Button variant="primary" size="lg" onClick={() => window.open('https://calendly.com/prabha-hubble/30min?month=2026-04', '_blank')} data-id="element-53">
              Book a Demo
            </Button>
          </motion.div>

          {/* Stat Pills */}
          <motion.div variants={itemVariants} className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-54">
            {['10x faster integration', '99.9% uptime', 'HIPAA compliant'].map((stat, index) => <div key={index} className="flex items-center gap-2 py-2 px-4 rounded-full border border-hubble-muted bg-hubble-border/50 backdrop-blur-sm" data-id="element-55">
                  <div className="w-1.5 h-1.5 rounded-full bg-hubble-accent animate-pulse-slow" data-id="element-56"></div>
                  <span className="font-body text-sm text-hubble-body" data-id="element-57">
                    {stat}
                  </span>
                </div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}